import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white add-user-card" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-6" }
const _hoisted_5 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Nom "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1)
const _hoisted_7 = { class: "col-md-6" }
const _hoisted_8 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Description "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1)
const _hoisted_10 = { class: "mb-7" }
const _hoisted_11 = {
  key: 0,
  class: "row"
}
const _hoisted_12 = { class: "form-check form-check-sm form-check-custom form-check-solid me-5 mb-5 me-lg-20" }
const _hoisted_13 = { class: "form-check-label" }
const _hoisted_14 = {
  key: 1,
  class: "row"
}
const _hoisted_15 = { class: "form-check form-check-sm form-check-custom form-check-solid me-5 mb-5 me-lg-20" }
const _hoisted_16 = { class: "form-check-label" }
const _hoisted_17 = { class: "col-md-12" }
const _hoisted_18 = { class: "d-flex align-items-center" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("button", {
  class: "default-btn me-20 transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success",
  type: "submit"
}, " Complèter ", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-delete lh-1 me-1 position-relative top-2" }, null, -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "position-relative" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Form, {
        ref: "roleForm",
        onSubmit: _ctx.editRole,
        "validation-schema": _ctx.roleSchema,
        "initial-values": _ctx.role
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createVNode(_component_Field, {
                  name: "nom",
                  type: "text",
                  readonly: "true",
                  class: "form-control shadow-none fs-md-15 text-black",
                  placeholder: "Entrer le nom"
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "nom",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _createVNode(_component_Field, {
                  type: "text",
                  readonly: "true",
                  class: "form-control shadow-none fs-md-15 text-black",
                  placeholder: "Ecriver la description",
                  name: "description"
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "description",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              (_ctx.estMarchand)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredPermissions, (privilege, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "col-sm-3 mb-5",
                        key: index
                      }, [
                        _createElementVNode("label", _hoisted_12, [
                          _createVNode(_component_Field, {
                            class: "form-check-input",
                            type: "checkbox",
                            value: privilege.id,
                            name: "privileges"
                          }, null, 8, ["value"]),
                          _createElementVNode("span", _hoisted_13, _toDisplayString(privilege.description), 1)
                        ])
                      ]))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.permissions, (privilege, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "col-sm-3 mb-5",
                        key: index
                      }, [
                        _createElementVNode("label", _hoisted_15, [
                          _createVNode(_component_Field, {
                            class: "form-check-input",
                            type: "checkbox",
                            value: privilege.id,
                            name: "privileges"
                          }, null, 8, ["value"]),
                          _createElementVNode("span", _hoisted_16, _toDisplayString(privilege.description), 1)
                        ])
                      ]))
                    }), 128)),
                    _createVNode(_component_ErrorMessage, {
                      name: "privileges",
                      class: "text-danger"
                    })
                  ])),
              _createVNode(_component_Field, {
                class: "form-check-input",
                type: "checkbox",
                visibility: "hidden",
                value: null,
                style: {"opacity":"0"},
                name: "privileges"
              })
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _hoisted_19,
                _createVNode(_component_router_link, {
                  to: "/liste-roles",
                  class: "btn btn-danger transition border-0 lh-1 fw-medium"
                }, {
                  default: _withCtx(() => [
                    _hoisted_20,
                    _hoisted_21,
                    _createTextVNode("Annuler")
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["onSubmit", "validation-schema", "initial-values"])
    ])
  ]))
}